export const getWorkoutName = (workout, block, includeBlockName = true) => {
    if (workout.name) {
        return includeBlockName ? `${block.name} ${workout.name}` : workout.name;
    }
    if (!includeBlockName) {
        return `${block.cycleLabel} ${workout.cycleSortOrder} (${block.sessionLabel} ${workout.sessionSortOrder})`;
    }
    return `${block.name} ${block.cycleLabel} ${workout.cycleSortOrder} (${block.sessionLabel} ${workout.sessionSortOrder})`;
};
export const getWorkoutStatus = (workoutStatus) => {
    switch (workoutStatus) {
        case 'completed':
            return 'Completed';
        case 'canceled':
            return 'Canceled';
        case 'skipped':
            return 'Skipped';
        case 'planned':
        default:
            return 'Planned';
    }
};
//# sourceMappingURL=utils.js.map